module.exports = __webpack_public_path__ + "img/polar bear.beb1fd5c.png";